module.exports = __webpack_public_path__ + "static/media/55_000051.23d6eda3.jpg";